import React, { useState } from "react";

// components
import { Maximize2 } from "lucide-react";
import Draggable from "react-draggable";

// Icons
import { MiniMicIcon } from "../../../assets/icons/mini-mic-icon";
import { MiniMessageIcon } from "../../../assets/icons/mini-message-icon";
import { MuteMiniMicIcon } from "../../../assets/icons/mute-mini-mic-icon";
import { MiniMessageIconHover } from "../../../assets/icons/mini-message-icon-hover";
import { MuteMiniMicIconHover } from "../../../assets/icons/mute-mini-mic-icon-hover";
import { MiniMicIconHover } from "../../../assets/icons/mini-mic-icon-hover";

const MiniCallingScreen = ({
  onChatClickMinView,
  isMiniScreen,
  callErrorMsg,
  setIsMiniScreen,
  isChat,
  setIsChat,
  handleHangup,
  label,
  pName,
  mute,
  unMuteCall,
  muteCall,
  status,
  maximizeCall,
}) => {
  const [callTime] = useState("01:01"); // Static timer for mockup
  const [isMinCallIconHover, setIsMinCallIconHover] = useState();
  const [isMuteHover, setIsMuteHover] = useState(false);
  const [isRecordingHover, setIsRecordingHover] = useState(false);
  const [isMessageHover, setIsMessageHover] = useState(false);
  return (
    <Draggable>
      <div
        className="fixed z-50 w-[394px] h-[394px] rounded-2xl bg-gradient-to-b from-[#FDF5F9] to-[#F0EFFC] shadow-lg p-5 text-center"
        style={{ bottom: "50px", left: "80px" }}
      >
        {/* Expand Icon */}
        <div className="flex justify-end mb-2">
          <button
            onClick={() => {
              setIsMiniScreen(false);
              setIsChat(false);
              maximizeCall();
            }}
          >
            <Maximize2 size={16} className="text-gray-400 cursor-pointer" />
          </button>
        </div>
        {/* Avatar */}
        <div className="mx-auto mb-3 w-16 h-16 rounded-full bg-[#f1e6dc] text-[#b79168] flex items-center justify-center text-xl font-semibold">
          {label}
        </div>
        {/* Name & Timer */}
        <h3 className="text-gray-800 font-semibold text-base">{pName}</h3>
        {callErrorMsg && (
          <p className="text-sm text-gray-500 mt-1">{callErrorMsg}</p>
        )}
        <p className="text-sm text-gray-500 mt-1">{status}</p>
        {/* Icons */}
        <div className="flex justify-center gap-6 mt-5">
          <div className="relative group inline-block">
            {mute ? (
              <button
                className="bg-white p-3 rounded-full hover:bg-gray-200"
                onClick={unMuteCall}
                onMouseEnter={() => {
                  setIsMuteHover(true);
                }}
                onMouseLeave={() => {
                  setIsMuteHover(false);
                }}
              >
                {isMuteHover ? <MuteMiniMicIconHover /> : <MuteMiniMicIcon />}
              </button>
            ) : (
              <button
                className="bg-white p-3 rounded-full hover:bg-gray-200"
                onClick={muteCall}
                onMouseEnter={() => {
                  setIsMuteHover(true);
                }}
                onMouseLeave={() => {
                  setIsMuteHover(false);
                }}
              >
                {isMuteHover ? <MiniMicIconHover /> : <MiniMicIcon />}
              </button>
            )}
            <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-[60px] h-[32px] bg-white text-[#1A1A1B] border border-[#E4E4E4] text-xs flex items-center justify-center rounded z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 font-medium">
              {mute ? "Unmute" : "Mute"}
            </div>
          </div>

          {/* Recording Button */}
          {/* <div className="relative group inline-block">
            <button
              className="bg-white p-3 rounded-full hover:bg-gray-200"
              onMouseEnter={() => {
                setIsRecordingHover(true);
              }}
              onMouseLeave={() => {
                setIsRecordingHover(false);
              }}
            >
              {isRecordingHover ? (
                <MiniRecordingIconHover />
              ) : (
                <MiniRecordingIcon />
              )}
            </button>
            <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-[70px] h-[32px] bg-white text-[#1A1A1B] border border-[#E4E4E4] text-xs flex items-center justify-center rounded z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              Record
            </div>
          </div> */}

          {/* Message Button */}
          <div className="relative group inline-block">
            <button
              className="bg-white p-3 rounded-full hover:bg-gray-200"
              onMouseEnter={() => {
                setIsMessageHover(true);
              }}
              onMouseLeave={() => {
                setIsMessageHover(false);
              }}
              onClick={onChatClickMinView}
            >
              {isMessageHover ? <MiniMessageIconHover /> : <MiniMessageIcon />}
            </button>
            <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-[150px] h-[32px] bg-white text-[#1A1A1B] border border-[#E4E4E4] text-xs flex items-center justify-center rounded z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 font-medium">
              View Conversation
            </div>
          </div>
        </div>
        {/* End Call Button */}
        {/* <button className="mt-8 px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition" onClick={handleHangup}>
                    Cancel Call
                </button> */}
        {!["Call ended", "No Answer"].includes(status) && (
          <>
            <button
              className="mt-8 px-6 py-2 bg-red-500 text-white rounded-md hover:bg-white hover:text-[#1A1A1B] hover:border hover:border-red-500 hover:px-[23.5px] hover:py-[7.5] transition"
              onClick={() => {
                //setCallingModal(false);
                //setIsChat(true);
                handleHangup();
              }}
              onMouseEnter={() => {
                setIsMinCallIconHover(true);
              }}
              onMouseLeave={() => {
                setIsMinCallIconHover(false);
              }}
            >
              <span className="flex justify-between">
                {["Calling", "Ringing"].includes(status) && (
                  <>
                    {isMinCallIconHover ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M8.11183 2.97505C7.05974 2.00832 5.44259 2.00832 4.3905 2.97505C4.34741 3.01464 4.30142 3.06065 4.24169 3.12039L3.34419 4.01788C2.44108 4.921 2.06196 6.22292 2.33902 7.4697C3.01964 10.5325 4.44123 13.3048 6.40871 15.5916L2.7807 19.2197C2.48781 19.5126 2.48781 19.9874 2.78071 20.2803C3.0736 20.5732 3.54847 20.5732 3.84137 20.2803L19.8413 4.28033C20.1342 3.98743 20.1342 3.51256 19.8413 3.21967C19.5484 2.92678 19.0735 2.92678 18.7806 3.21967L11.0954 10.9049L10.8864 10.6959C10.3024 10.1119 10.1354 9.22994 10.4654 8.47283C11.0418 7.15037 10.7501 5.60984 9.72999 4.58974L8.26066 3.12041C8.20093 3.06066 8.15492 3.01464 8.11183 2.97505Z"
                          fill="#1A1A1B"
                        />
                        <path
                          d="M16.5094 21.6401C13.4859 20.9682 10.7455 19.5743 8.47578 17.6459L13.1561 12.9656L13.2832 13.0927C13.8672 13.6767 14.7492 13.8437 15.5063 13.5137C16.8287 12.9372 18.3693 13.229 19.3894 14.2491L20.8586 15.7184C20.9184 15.7781 20.9644 15.8241 21.004 15.8673C21.9708 16.9193 21.9708 18.5365 21.004 19.5886C20.9644 19.6317 20.9184 19.6777 20.8586 19.7375L19.9612 20.6349C19.0581 21.538 17.7562 21.9171 16.5094 21.6401Z"
                          fill="#1A1A1B"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M3.3125 19.75L19.3124 3.75"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M5.15541 3.82664C5.63363 3.38721 6.3687 3.38721 6.84692 3.82664C6.86343 3.84181 6.88507 3.8632 6.96114 3.93927L8.41933 5.39747C9.00333 5.98147 9.17036 6.86342 8.84034 7.62052C8.26388 8.94299 8.55563 10.4835 9.57573 11.5036L10.5044 12.4323C10.7973 12.7252 11.2722 12.7252 11.5651 12.4323C11.858 12.1394 11.858 11.6645 11.5651 11.3716L10.6364 10.443C10.0524 9.85895 9.88536 8.97701 10.2154 8.2199C10.7918 6.89744 10.5001 5.35691 9.47999 4.33681L8.01066 2.86748C7.95093 2.80773 7.90492 2.76171 7.86183 2.72212C6.80974 1.75539 5.19259 1.75539 4.1405 2.72212C4.09741 2.76171 4.05142 2.80772 3.99169 2.86746L3.09419 3.76496C2.19108 4.66807 1.81196 5.96999 2.08902 7.21677C2.84746 10.6297 4.52596 13.682 6.85464 16.1037C7.1375 16.3979 7.60514 16.3922 7.8937 16.1037C8.19079 15.8066 8.18434 15.3244 7.89419 15.0206C5.77434 12.8005 4.24624 10.0096 3.5533 6.89137C3.3875 6.14523 3.61438 5.36609 4.15485 4.82562L5.0412 3.93927C5.11726 3.86321 5.1389 3.84181 5.15541 3.82664Z"
                          fill="white"
                        />
                        <path
                          d="M10.0998 16.9661C9.79087 16.7375 9.35913 16.7596 9.08735 17.0313C8.77211 17.3466 8.7974 17.8663 9.15481 18.1327C11.2286 19.6789 13.6376 20.8045 16.2594 21.3871C17.5062 21.6642 18.8081 21.2851 19.7112 20.382L20.6086 19.4846C20.6684 19.4248 20.7144 19.3788 20.754 19.3357C21.7208 18.2836 21.7208 16.6664 20.754 15.6143C20.7144 15.5712 20.6684 15.5252 20.6086 15.4654L19.1394 13.9962C18.1193 12.9761 16.5787 12.6843 15.2563 13.2608C14.7733 13.4713 14.2396 13.4796 13.7648 13.3064C13.3925 13.1706 12.9462 13.1725 12.6659 13.4528C12.3571 13.7616 12.3677 14.2746 12.7494 14.4867C13.6893 15.0088 14.8371 15.0798 15.8556 14.6358C16.6127 14.3058 17.4947 14.4728 18.0787 15.0568L19.5369 16.515C19.6129 16.5911 19.6343 16.6127 19.6495 16.6292C20.0889 17.1075 20.0889 17.8425 19.6495 18.3207C19.6343 18.3373 19.6129 18.3589 19.5369 18.435L18.6505 19.3213C18.1101 19.8618 17.3309 20.0887 16.5848 19.9229C14.1942 19.3916 11.9959 18.3695 10.0998 16.9661Z"
                          fill="white"
                        />
                      </svg>
                    )}
                    &nbsp;&nbsp;Cancel Call
                  </>
                )}
                {status &&
                  status.indexOf(":") > 0 &&
                  (isMinCallIconHover ? (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_21550_99648)">
                          <path
                            d="M21.5924 17.4042C23.0199 17.3439 24.1634 16.2004 24.2237 14.7728C24.2262 14.7144 24.2262 14.6493 24.2262 14.5648L24.2262 13.2956C24.2262 12.0184 23.5737 10.8297 22.4962 10.144C16.3826 6.25361 8.56977 6.25361 2.45624 10.144C1.37872 10.8297 0.726205 12.0184 0.726203 13.2956L0.726203 14.5647C0.726192 14.6493 0.726186 14.7144 0.728659 14.7728C0.789015 16.2004 1.93252 17.3439 3.36004 17.4042C3.41853 17.4067 3.48361 17.4067 3.56815 17.4067L5.646 17.4067C7.08864 17.4067 8.38426 16.5237 8.91177 15.1809C9.21376 14.4122 9.9555 13.9067 10.7814 13.9067L14.171 13.9067C14.9969 13.9067 15.7386 14.4122 16.0406 15.1809C16.5681 16.5237 17.8638 17.4067 19.3064 17.4067L21.3844 17.4067C21.4688 17.4067 21.5339 17.4067 21.5924 17.4042Z"
                            fill="#1A1A1B"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_21550_99648">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                              transform="translate(0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      &nbsp;&nbsp;End Call
                    </>
                  ) : (
                    <>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M21.108 17.6244C22.5355 17.5641 23.679 16.4206 23.7394 14.9931C23.7418 14.9346 23.7418 14.8695 23.7418 14.7851L23.7418 13.5158C23.7418 12.2386 23.0893 11.0499 22.0118 10.3643C15.8983 6.47383 8.08539 6.47383 1.97187 10.3643C0.894346 11.0499 0.241831 12.2386 0.24183 13.5158V14.7849C0.241819 14.8695 0.241812 14.9346 0.244286 14.9931C0.304641 16.4206 1.44814 17.5641 2.87566 17.6244C2.93415 17.6269 2.99924 17.6269 3.08378 17.6269L5.16163 17.6269C6.60427 17.6269 7.89989 16.7439 8.42739 15.4011C8.72939 14.6324 9.47112 14.1269 10.297 14.1269L13.6866 14.1269C14.5125 14.1269 15.2543 14.6324 15.5563 15.4011C16.0838 16.7439 17.3794 17.6269 18.822 17.6269L20.9 17.6269C20.9845 17.6269 21.0495 17.6269 21.108 17.6244ZM22.2407 14.9297C22.2133 15.5786 21.6935 16.0983 21.0446 16.1258C21.0222 16.1267 20.9918 16.1269 20.8842 16.1269L18.822 16.1269C17.9961 16.1269 17.2544 15.6214 16.9524 14.8527C16.4249 13.5099 15.1293 12.6269 13.6866 12.6269L10.297 12.6269C8.85439 12.6269 7.55877 13.5099 7.03127 14.8527C6.72927 15.6214 5.98753 16.1269 5.16163 16.1269L3.09943 16.1269C2.99186 16.1269 2.96143 16.1267 2.93903 16.1258C2.29015 16.0983 1.77038 15.5786 1.74295 14.9297C1.742 14.9073 1.74183 14.8769 1.74183 14.7693V13.5158C1.74183 12.7515 2.13233 12.0401 2.77718 11.6297C8.39936 8.052 15.5843 8.052 21.2065 11.6297C21.8513 12.0401 22.2418 12.7515 22.2418 13.5158L22.2418 14.7693C22.2418 14.8769 22.2417 14.9073 22.2407 14.9297Z"
                          fill="white"
                        />
                      </svg>
                      &nbsp;&nbsp;End Call
                    </>
                  ))}
              </span>
            </button>
          </>
        )}
      </div>
    </Draggable>
  );
};

export default MiniCallingScreen;
